function ConsultingController(containerObject){
	/* THIS FIX */
	var _this = this;
	
	/* PRIVATE CONSTANTS */
	
	
	/* PRIVATE VARIABLES */
	var btnShow;
	var formContainer;
	var consultingForm;
	

	/* PUBLIC PROPERTIES */
	this.container = null;
	this.inited = false;
	
	
	/* PRIVATE FUNCTIONS */
	function _construct(){
		_this.container = containerObject;
		_this.init();
	}	
	
	
	function showForm(){
		formContainer.slideDown();
		$('#show-button-container').slideUp();	
		setTimeout(consultingForm.focus, 500);
	}
	
	
	function checkOpenFormOnLoad(){
		if(window.location.hash){
			var hash = window.location.hash.substring(1);
			if(hash === 'new') {
				return true;
			}
		}
		return false;
	}
		
	
	/* PUBLIC FUNCTIONS */	
	this.init = function(){
		if(!_this.inited){	
			
			// object references
			btnShow = $('.button.show-consulting-form');
			formContainer = $('#consulting-form-container');
			
			// handlers
			btnShow.click(function(e) {
				e.preventDefault();
				showForm();
			});
			
			// init
			consultingForm = new ConsultingForm(formContainer);
			if(checkOpenFormOnLoad()){
				showForm();
			}

			_this.inited = true;
		}
	};
	

	/* INIT CONSTRUCTOR */
	_construct();
}


/* PUBLIC CONSTANTS */
